import React, { useState, useEffect } from 'react';
import UIBody from '../../../components/ui/UIBody';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import useApiCallHooks from '../../../hooks/useApiCallHooks';

const Contactus = () => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    mobile_no: '',
    type: '',
    description: '',
  });

  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  // Handle form input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    callAPI('post', 'add-contact-us', formData);
  };

  // Handle response
  useEffect(() => {
    if (responce?.data && statusCode === 200) {
      toast.success('Your message has been sent successfully!');
      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        mobile_no: '',
        type: 'project',
        message: '',
      });
    }

    if (responce?.data && statusCode === 201) {
      toast.success('Contact created successfully!');
      setTimeout(() => {
        navigate('/');
      }, 1500);
    }

    if (error?.message === 'ValidationError') {
      toast.error('Please check the highlighted fields.');
    }
  }, [responce, statusCode, error, navigate]);

  const styles = {
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '40px',
      padding: '40px',
      background: '#fff',
      fontFamily: 'Arial, sans-serif',
    },
    left: {
      flex: '1 1 300px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
    },
    card: {
      background: '#fff',
      border: '1px solid #eee',
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '15px',
      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
    },
    iconCircle: {
      backgroundColor: '#003E9F',
      color: '#fff',
      borderRadius: '50%',
      fontSize: '20px',
      width: '45px',
      height: '45px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    heading: {
      margin: '0 0 5px',
      fontSize: '18px',
      fontWeight: '600',
    },
    paragraph: {
      margin: 0,
      color: '#555',
      lineHeight: '1.4',
    },
    right: {
      flex: '1 1 500px',
      background: '#fff',
      borderRadius: '12px',
      padding: '30px',
      border: '1px solid #eee',
      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
    },
    rightTitle: {
      marginBottom: '10px',
      fontSize: '22px',
      fontWeight: '700',
    },
    subText: {
      marginBottom: '20px',
      color: '#666',
      fontSize: '14px',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    textarea: {
      width: '100%',
      minHeight: '100px',
      marginBottom: '15px',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '6px',
      resize: 'vertical',
      fontSize: '14px',
    },
    inputGroup: {
      display: 'flex',
      gap: '10px',
      marginBottom: '15px',
      flexWrap: 'wrap',
    },
    input: {
      flex: '1',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '6px',
      fontSize: '14px',
      minWidth: '150px',
    },
    button: {
      backgroundColor: '#003E9F',
      color: 'white',
      padding: '12px 30px',
      border: 'none',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
      boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
      transition: 'background-color 0.3s',
    },
    mapContainer: {
      marginTop: '30px',
      borderRadius: '12px',
      overflow: 'hidden',
      border: '1px solid #ccc',
      boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
    },
    mapIframe: {
      width: '100%',
      height: '300px',
      border: 'none',
    },
    errorText: {
      color: 'red',
      fontSize: '12px',
      marginTop: '-10px',
      marginBottom: '10px',
    },
  };

  return (
    <UIBody
    loading={loading}
      content={
        <>
          <div style={styles.container}>
            {/* Left Section */}
            <div style={styles.left}>
              <div style={styles.card}>
                <div style={styles.iconCircle}><FaMapMarkerAlt /></div>
                <div>
                  <h3 style={styles.heading}>Address</h3>
                  <p style={styles.paragraph}>
                    Office no 204 Shree Ganesh Galaxy, Alandi Road<br />
                    Wadmukhwadi, Pune. PinCode - 411081<br />
                    Pune
                  </p>
                </div>
              </div>

              <div style={styles.card}>
                <div style={styles.iconCircle}><FaPhoneAlt /></div>
                <div>
                  <h3 style={styles.heading}>Phone</h3>
                  <p style={styles.paragraph}>
                    +91- 9860491861<br />
                    +91- 9834143101
                  </p>
                </div>
              </div>

              <div style={styles.card}>
                <div style={styles.iconCircle}><FaEnvelope /></div>
                <div>
                  <h3 style={styles.heading}>E-mail Address</h3>
                  <p style={styles.paragraph}>support@sysinsightsolutions.com</p>
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div style={styles.right}>
              <h2 style={styles.rightTitle}>Send Us Message</h2>
              <p style={styles.subText}>
                Your email address will not be published. Required fields are marked *
              </p>
                <form className="account__form" onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="first-name">First Name</label>
              <input
                type="text"
                className="form-control"
                id="first-name"
                name="first_name"
                placeholder="First Name"
                value={formData.first_name}
                onChange={handleChange}
              />
              {error?.message === "ValidationError" && (
                <span className="text-danger small">{error?.data?.first_name}</span>
              )}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label htmlFor="last-name">Last Name</label>
              <input
                type="text"
                className="form-control"
                id="last-name"
                name="last_name"
                placeholder="Last Name"
                value={formData.last_name}
                onChange={handleChange}
              />
              {error?.message === "ValidationError" && (
                <span className="text-danger small">{error?.data?.last_name}</span>
              )}
            </div>
          </div>
        </div>
        <div className="row g-3">
            <div className=" col-6 mt-3">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
          />
          {error?.message === "ValidationError" && (
            <span className="text-danger small">{error?.data?.email}</span>
          )}
        </div>

        <div className="col-6 mt-3">
          <label htmlFor="mobile">Mobile No</label>
          <input
            type="number"
            className="form-control"
            id="mobile"
            name="mobile_no"
            placeholder="Mobile No"
            value={formData.mobile_no}
            onChange={handleChange}
          />
          {error?.message === "ValidationError" && (
            <span className="text-danger small">{error?.data?.mobile_no}</span>
          )}
        </div>
        </div>

      

        <div className="form-group mt-3">
          <label htmlFor="description">Description</label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="2"
            placeholder="Write your message here..."
            value={formData.description}
            onChange={handleChange}
          ></textarea>
          {error?.message === "ValidationError" && (
            <span className="text-danger small">{error?.data?.description}</span>
          )}
        </div>

  <div className="form-group mt-3">
  <label htmlFor="type">Type</label>
  <select
    name="type"
    id="type"
    className="form-control"
    value={formData.type}
    onChange={handleChange}
  >
    <option value="">Select Type</option>
    <option value="project">Project</option>
    <option value="program">Program</option>
    <option value="robotic">Robotic</option>
    <option value="kids">Kids</option>
  </select>
</div>


        <div className="text-center mt-4">
          <button type="submit" className="btn btn-primary px-4 py-2 rounded-pill">
            Submit Request
          </button>
        </div>
      </form>
            </div>
          </div>

          {/* Map Section */}
          <div style={styles.mapContainer}>
            <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3780.345101759912!2d73.87726587410314!3d18.648503665256026!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c7c849a5d491%3A0x572e5adf0bb7e62d!2sShree%20Ganesh%20Galaxy!5e0!3m2!1sen!2sin!4v1687770837234!5m2!1sen!2sin"
      width="100%"
      height="350"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Sysinsight Soluation"
    ></iframe>
          </div>
        </>
      }
    />
  );
};

export default Contactus;